import { useState } from "react";
import { categories } from "@/mocks/categories";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah76v3oh653ivfvnmvg";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      return;
    }

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      params.append(key, typeof value === "string" ? value : value.name);
    });

    setStatus("loading");
    setFormError("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");

      if (!response.ok || code !== "OK" || isSpam) {
        setFormError(serverMsg || "提交失败，请稍后重试");
        setStatus("error");
        return;
      }

      setStatus("success");
      form.reset();
    } catch {
      setFormError("网络异常，请稍后重试");
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className="rounded-lg border border-accent-300 bg-accent-50 p-6 text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-accent-500 text-background-50">
          <i className="ri-check-line text-2xl" />
        </span>
        <p className="mt-3 font-heading text-lg font-bold text-foreground-950">订阅成功</p>
        <p className="mt-1 text-sm text-foreground-600">新料一出，我们会第一时间推送到你的邮箱。</p>
      </div>
    );
  }

  return (
    <form
      data-readdy-form
      onSubmit={handleSubmit}
      className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label htmlFor="subscribe-email" className="mb-1.5 block text-xs font-medium text-foreground-700">
            邮箱地址
          </label>
          <input
            id="subscribe-email"
            type="email"
            name="email"
            required
            placeholder="you@example.com"
            className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
          />
        </div>
        <div>
          <label htmlFor="subscribe-interest" className="mb-1.5 block text-xs font-medium text-foreground-700">
            关注方向
          </label>
          <select
            id="subscribe-interest"
            name="interest"
            defaultValue="yule"
            className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
          >
            {categories.map((cat) => (
              <option key={cat.slug} value={cat.slug}>
                {cat.name}
              </option>
            ))}
            <option value="all">全部栏目</option>
          </select>
        </div>
      </div>

      <input
        type="text"
        name="website_alt"
        className="field-verify-extra"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {status === "error" && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700">
          <i className="ri-error-warning-line text-base" />
          {formError}
        </p>
      )}

      <button
        type="submit"
        disabled={status === "loading"}
        className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto"
      >
        <i className={status === "loading" ? "ri-loader-4-line animate-spin text-base" : "ri-notification-3-line text-base"} />
        {status === "loading" ? "提交中..." : "订阅独家爆料"}
      </button>
      <p className="mt-2.5 text-xs text-foreground-500">我们仅用于推送爆料更新，可随时退订。</p>
    </form>
  );
}